export const STATUS_QUERY = require('./status');
export const REFS_QUERY = require('./refs');
export const STASHES_QUERY = require('./stashes');
export const HEAD_CONTENT_QUERY = require('./headContent');
export const AUTH_DATA = require('./auth');

